import { type AxiosError } from 'axios'
import { useEffect, useState } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { TokenExpiredError } from 'rate-command-center/domain/errors/TokenExpiredError'

import { getPendingTenders } from '../../use-cases/getPendingTenders'

export function usePendingTenders({ token }: { token: string }) {
  const {
    call: fetchPendingTenders,
    result: pendingTenders,
    status: pendingTendersRequestStatus,
    error,
  } = useAsync(getPendingTenders)

  const abortController = useAbortController()

  const [isTokenExpired, setIsTokenExpired] = useState(false)

  const isLoading = pendingTendersRequestStatus === 'pending'

  useEffect(() => {
    const responseError = error

    setIsTokenExpired(responseError instanceof TokenExpiredError)
  }, [error])

  useEffect(() => {
    fetchPendingTenders({
      token,
      config: { signal: abortController.signal },
    })

    return () => {
      abortController.abort()
    }
  }, [abortController, fetchPendingTenders, token])

  return {
    pendingTenders,
    pendingTendersRequestStatus,
    error: error as AxiosError | undefined,
    isTokenExpired,
    fetchPendingTenders,
    isLoading,
  }
}
